import { isAxiosError } from 'axios';

export const UNSUPPORTED_FILE_MESSAGE = 'Unsupported file. Please upload a PDF, JPG or PNG.';
export const FILE_TOO_LARGE_MESSAGE = 'File is too large. Please upload a smaller file.';
export const UPLOAD_FAILED_MESSAGE = "Couldn't upload the file. Please try again.";

/**
 * Short, fixed message for a document the server refused before upload
 * (POST .../claim/{id}/document/ -> base-api get-upload-signed-url). The
 * server's own wording is never shown: it would tell an attacker which file
 * rule was hit (VAPT WEB-001). Only the field that failed picks the message:
 * { error: { data: { filename | fileSize | sizeBytes: [...] } } }.
 */
const getUploadRejectionMessage = (error: unknown): string => {
  if (!isAxiosError(error)) {
    return UPLOAD_FAILED_MESSAGE;
  }
  const status = error.response?.status ?? 0;
  if (status < 400 || status >= 500) {
    return UPLOAD_FAILED_MESSAGE;
  }
  const data = (
    error.response?.data as { error?: { data?: Record<string, unknown> } } | undefined
  )?.error?.data;
  if (data?.fileSize != null || data?.sizeBytes != null) {
    return FILE_TOO_LARGE_MESSAGE;
  }
  if (data?.filename != null) {
    return UNSUPPORTED_FILE_MESSAGE;
  }
  return UPLOAD_FAILED_MESSAGE;
};

export default getUploadRejectionMessage;
